const mEditionBillingMyPaymentsChangePlanModalDisabled = {
  mEditionBillingMyPaymentsChangePlanModalDisabled: {
    messages: 'Esta acción está inhabilitada, no puedes cambiarte a un plan de características inferiores.',
    title: 'Atención'
  }
}

export default mEditionBillingMyPaymentsChangePlanModalDisabled
